import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getWarrantyTypes = createAsyncThunk(
  '/getWarrantyTypes',
  async () => {
    const response = await axios.get('/GetWarrantyTypes');
    return response.data;
  }
);

export const getWarrantyTypeDetails = createAsyncThunk(
  '/getWarrantyTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetWarrantyTypeDetails/${id}`);
    return response.data;
  }
);

export const getCostCodeList = createAsyncThunk(
  '/getCostCodeList',
  async () => {
    const response = await axios.get('/GetCostCodeList/');
    return response.data;
  }
);
export const getWarrantyGroupList = createAsyncThunk(
  '/GetWarrantyGroupList',
  async () => {
    const response = await axios.get('/GetWarrantyGroupList/');
    return response.data;
  }
);
export const getWarrantyPaymentGroupTypes = createAsyncThunk(
  '/getWarrantyPaymentGroupTypes',
  async () => {
    const response = await axios.get('/GetWarrantyPaymentGroupTypes/');
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);
export const getWarrantyTime = createAsyncThunk(
  '/GetWarrantyTime',
  async (req) => {
    const response = await axios.post('/GetWarrantyTime', req);
    return response.data;
  }
);
export const setWarrantyTime = createAsyncThunk(
  '/SetWarrantyTime',
  async (req) => {
    const response = await axios.post('/SetWarrantyTime', req);
    return response.data;
  }
);

export const getSiriusWarrantyType = createAsyncThunk('/GetSiriusWarrantyType', async () => {
  const response = await axios.get(`/GetSiriusWarrantyType`);
  return response.data;
});

export const getWarrantyExceptions = createAsyncThunk(
  '/getWarrantyExceptions',
  async (id) => {
    const response = await axios.get(`/GetWarrantyExceptions/${id}`);
    return response.data;
  }
);


const warrantyTypeSlice = createSlice({
  name: 'warranty',
  initialState: {
    loading: false,
    error: '',
    warrantyTypes: [],
    warrantyTypeDescriptions: [],
    warrantyTimes: [],
    SelectedWarrantyGroupId: 0,
    SelectedWarrantyGroup: '',
    SelectedAppTranslationId: 0,
    SelectedPaymentGroupId: 0,
    SelectedPaymentGroup: '',
    IsChecked: true,
    response: '',
    WarrantyGroupList: [],
    CostCodeList: [],
    PaymentGroupList: [],
    CostCode: '',
    WarrantyException:[],
    WarrantyInfo:[]
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.warrantyTypeDescriptions = [];
      state.SelectedWarrantyGroupId = 0;
      state.SelectedWarrantyGroup= '';
      state.SelectedPaymentGroupId = 0;
      state.SelectedPaymentGroup= '';
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeCostCode(state, action) {
      state.CostCode = action.payload;
    },
    changeWarrantyGroup(state, action) {
      state.SelectedWarrantyGroup = action.payload;
      state.SelectedWarrantyGroupId = state.WarrantyGroupList.find((m) => m.Description === state.SelectedWarrantyGroup).Id;
    },
    changePaymentGroup(state, action) {
      state.SelectedPaymentGroup = action.payload;
      state.SelectedPaymentGroupId = state.PaymentGroupList.find((m) => m.Dsc === state.SelectedPaymentGroup).Id;
    }
  },
  extraReducers: {
    [getWarrantyTypes.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyTypes.fulfilled]: (state, action) => {
      state.warrantyTypes = action.payload;
      state.loading = false;
    },
    [getWarrantyTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyTypeDetails.fulfilled]: (state, action) => {
      state.warrantyTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.warrantyTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getWarrantyGroupList.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyGroupList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyGroupList.fulfilled]: (state, action) => {
      state.WarrantyGroupList = action.payload;
      state.loading = false;
    },
    [getWarrantyPaymentGroupTypes.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyPaymentGroupTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyPaymentGroupTypes.fulfilled]: (state, action) => {
      state.PaymentGroupList = action.payload;
      state.loading = false;
    },
    [getCostCodeList.pending]: (state) => {
      state.loading = true;
    },
    [getCostCodeList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCostCodeList.fulfilled]: (state, action) => {
      state.CostCodeList = action.payload;
      state.loading = false;
    },
    [getWarrantyTime.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyTime.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyTime.fulfilled]: (state, action) => {
      state.warrantyTimes = action.payload;
      state.loading = false;
    },
    [getSiriusWarrantyType.pending]: (state) => {
        state.loading = true;
    },
    [getSiriusWarrantyType.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
    },
    [getSiriusWarrantyType.fulfilled]: (state, action) => {
        state.WarrantyException = action.payload;
        state.loading = false;
    },
    [getWarrantyExceptions.pending]: (state) => {
        state.loading = true;
    },
    [getWarrantyExceptions.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
    },
    [getWarrantyExceptions.fulfilled]: (state, action) => {
        state.WarrantyInfo = action.payload;
        state.loading = false;
    },
  }
});

export const warrantyActions = warrantyTypeSlice.actions;

export default warrantyTypeSlice;
